class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
document.addEventListener("DOMContentLoaded", function() {
    const searchForm = document.querySelector('form[action*="/search"]');
    const searchInput = searchForm.querySelector('input[name="q"]');

    if (!searchForm || !searchInput) return;

    searchForm.addEventListener("submit", function(event) {
        event.preventDefault(); // Stop default search submission
        const query = searchInput.value.trim();

        if (query.length > 2) {
            fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=1`)
                .then(response => response.json())
                .then(data => {
                    if (data.resources.results.products.length > 0) {
                        const product = data.resources.results.products[0];
                        window.location.href = product.url; // Redirect to the product page
                    } else {
                        searchForm.submit(); // If no exact match, continue to search results page
                    }
                })
                .catch(error => {
                    console.error("Search error:", error);
                    searchForm.submit(); // Fallback if something goes wrong
                });
        } else {
            searchForm.submit();
        }
    });
});

